import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { EMPTY, from, Observable, of, Subject } from 'rxjs';
import { catchError, switchMap, tap, timeout } from 'rxjs/operators';
import { LoadingService } from './loading.service';
//https://github.com/ionic-team/ionic-storage

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;
  private onSubject = new Subject<{ key: string, value: any }>();
  public changes = this.onSubject;
  //filter out intial value
  public storageCleared$ = new Subject();

  //No need to call https://stackoverflow.com/questions/35397198/how-can-i-watch-for-changes-to-localstorage-in-angular2
  //this.onSubject.asObservable().pipe(share());

  constructor(private storage: Storage,
    private loading : LoadingService) {
  }
  
   private getStorage() : Observable<Storage> {  
    if(this._storage) {
      return of(this._storage);
    } else {
      return from(this.storage.create()).pipe(
        timeout(1000), tap(
        (val:Storage) => {
          this._storage = val;         
        }),
        catchError((error) => {
          this.loading.presentToast('Timeout during storage access');
          console.log('Timeout during storage access', error);
          return EMPTY;
          }
        )); 
      }  
  }

  set(key: string, value: any) {
  this.onSubject.next({key: key, value: value});  
   return this.getStorage().pipe(switchMap(
      (storage:Storage) => storage.set(key, value))).toPromise();      
  }

  get(key: string) : Promise<any>
  {
    return this.getStorage().pipe(switchMap(
      (storage:Storage) => storage.get(key))).toPromise();     
  }

  clear() {    
    this.storageCleared$.next();
    return this.getStorage().pipe(switchMap(
      (storage:Storage) => storage.clear())).toPromise(); 
  } 

  async clearStorageWithoutLogout(currentUser) { 
    await this._storage.clear();
    console.log("Resetting user in storage before clearing: ", currentUser)
    await this._storage.set('User', currentUser);
    console.log("Storage cleared"); 
    this.storageCleared$.next();
  }
}

